import React from 'react'
import { Editor } from '@tinymce/tinymce-react'

function App() {
  return (
    <div>
      <Editor
        apiKey="ulnbmvk70w889b8sjysrgv7zyv3ow05wl2zi1kpt33j4hwhu"
        initialValue="<p>Initial content</p>"
        init={{
          menubar: false,
          plugins: [
            'advlist autolink lists link image',
            'charmap print preview anchor help',
            'searchreplace visualblocks code',
            'insertdatetime media table paste',
            'quickbars'
          ],
          toolbar:
            'formatselect | bold italic | \
            alignleft aligncenter alignright | \
            bullist numlist outdent indent | help'
        }}
        onChange={e =>
          console.log('Content was updated:', e?.target.getContent())
        }
      />
    </div>
  )
}

export default App
